import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "space-y-8" }
const _hoisted_2 = { class: "bg-white rounded-xl shadow-sm border border-gray-200 p-6" }
const _hoisted_3 = { class: "grid md:grid-cols-2 gap-4 text-sm" }
const _hoisted_4 = { class: "font-medium text-gray-900" }
const _hoisted_5 = { class: "text-xs font-mono text-gray-700" }
const _hoisted_6 = { class: "font-medium text-gray-900" }
const _hoisted_7 = { class: "bg-white rounded-xl shadow-sm border border-gray-200 p-6" }
const _hoisted_8 = { class: "text-sm text-gray-500 mb-4" }
const _hoisted_9 = { class: "text-gray-900" }
const _hoisted_10 = {
  key: 0,
  class: "bg-amber-50 border border-amber-200 rounded-lg p-4 text-sm text-amber-900"
}
const _hoisted_11 = {
  key: 1,
  class: "text-sm text-gray-600"
}
const _hoisted_12 = { class: "bg-white rounded-xl shadow-sm border border-gray-200 p-6" }
const _hoisted_13 = { class: "flex items-center justify-between mb-4" }
const _hoisted_14 = { class: "divide-y divide-gray-200 border border-gray-200 rounded-lg overflow-hidden" }
const _hoisted_15 = {
  key: 0,
  class: "p-4 animate-pulse"
}
const _hoisted_16 = { class: "flex items-center gap-3 min-w-0" }
const _hoisted_17 = { class: "w-9 h-9 rounded-full bg-gray-100 flex items-center justify-center flex-shrink-0" }
const _hoisted_18 = { class: "min-w-0" }
const _hoisted_19 = { class: "text-sm font-medium text-gray-900 truncate" }
const _hoisted_20 = { class: "text-xs text-gray-500" }
const _hoisted_21 = { class: "flex items-center gap-3 flex-shrink-0" }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = { class: "bg-white rounded-2xl shadow-2xl max-w-md w-full" }
const _hoisted_24 = { class: "p-6 border-b border-gray-200 flex items-center justify-between" }
const _hoisted_25 = { class: "grid grid-cols-2 gap-3" }
const _hoisted_26 = {
  key: 0,
  class: "bg-red-50 border border-red-200 rounded-lg p-3"
}
const _hoisted_27 = { class: "text-sm text-red-600" }
const _hoisted_28 = { class: "flex gap-3 pt-2" }
const _hoisted_29 = ["disabled"]

import { ref, onMounted } from 'vue'
import { Icon } from '@iconify/vue'
import { authClient } from '../services/api'
import { useAuthStore } from '../store/auth'
import { useNotification } from '../composables/useNotification'


export default /*@__PURE__*/_defineComponent({
  __name: 'SettingsView',
  setup(__props) {

const authStore = useAuthStore()
const notify = useNotification()

const members = ref<any[]>([])
const loading = ref(true)
const showModal = ref(false)
const saving = ref(false)
const error = ref('')

const form = ref({ firstname: '', lastname: '', phone: '' })

onMounted(load)

// Les comptes sont gérés côté production (source de vérité) puis mirroités
// vers l'environnement sandbox : cet écran parle donc toujours à la prod.
async function load() {
  loading.value = true
  try {
    const { data } = await authClient.get('/partner-portal/members')
    members.value = data.members || []
  } catch (err) {
    console.error('Erreur chargement membres:', err)
    members.value = []
  } finally {
    loading.value = false
  }
}

async function addMember() {
  saving.value = true
  error.value = ''
  try {
    await authClient.post('/partner-portal/members', form.value)
    showModal.value = false
    form.value = { firstname: '', lastname: '', phone: '' }
    notify.success('Développeur ajouté')
    await load()
  } catch (err: any) {
    error.value = err.response?.data?.message || "Erreur lors de l'ajout"
  } finally {
    saving.value = false
  }
}

async function removeMember(member: any) {
  if (
    !window.confirm(
      `Retirer ${member.user.firstname} ${member.user.lastname} de l'équipe ? Son accès au portail sera immédiatement coupé.`
    )
  ) {
    return
  }
  try {
    await authClient.delete(`/partner-portal/members/${member.id}`)
    notify.success('Membre retiré')
    await load()
  } catch (err: any) {
    notify.error(err.response?.data?.message || 'Erreur')
  }
}

function billingLabel(mode?: string | null): string {
  return (
    {
      PER_DELIVERY: 'Paiement à la course',
      PREPAID_WALLET: 'Wallet prépayé',
      MONTHLY_INVOICE: 'Facture mensuelle',
    } as Record<string, string>
  )[mode || ''] || '—'
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _cache[11] || (_cache[11] = _createElementVNode("h3", { class: "font-semibold text-gray-900 mb-4" }, "Compte partenaire", -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", null, [
          _cache[7] || (_cache[7] = _createElementVNode("p", { class: "text-gray-500" }, "Entreprise", -1)),
          _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(authStore).partner?.name), 1)
        ]),
        _createElementVNode("div", null, [
          _cache[8] || (_cache[8] = _createElementVNode("p", { class: "text-gray-500" }, "Statut", -1)),
          _createElementVNode("span", {
            class: _normalizeClass([
              'inline-block px-3 py-1 rounded-full text-xs font-semibold mt-0.5',
              _unref(authStore).isSuspended ? 'bg-red-100 text-red-800' : 'bg-green-100 text-green-800'
            ])
          }, _toDisplayString(_unref(authStore).isSuspended ? 'Suspendu' : 'Actif'), 3)
        ]),
        _createElementVNode("div", null, [
          _cache[9] || (_cache[9] = _createElementVNode("p", { class: "text-gray-500" }, "Identifiant partenaire", -1)),
          _createElementVNode("code", _hoisted_5, _toDisplayString(_unref(authStore).partner?.id), 1)
        ]),
        _createElementVNode("div", null, [
          _cache[10] || (_cache[10] = _createElementVNode("p", { class: "text-gray-500" }, "Votre rôle", -1)),
          _createElementVNode("p", _hoisted_6, _toDisplayString(_unref(authStore).isOwner ? 'Propriétaire' : 'Développeur'), 1)
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_7, [
      _cache[15] || (_cache[15] = _createElementVNode("h3", { class: "font-semibold text-gray-900 mb-1" }, "Facturation", -1)),
      _createElementVNode("p", _hoisted_8, [
        _cache[12] || (_cache[12] = _createTextVNode(" Mode actuel : ", -1)),
        _createElementVNode("strong", _hoisted_9, _toDisplayString(billingLabel(_unref(authStore).partner?.billingMode)), 1)
      ]),
      (_unref(authStore).partner?.requestedBillingMode)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("p", null, [
              _cache[13] || (_cache[13] = _createTextVNode(" Votre demande de passage en ", -1)),
              _createElementVNode("strong", null, _toDisplayString(billingLabel(_unref(authStore).partner.requestedBillingMode)), 1),
              _cache[14] || (_cache[14] = _createTextVNode(" est en cours de validation par l'équipe Youdégo. Le mode actuel reste actif jusqu'à approbation. ", -1))
            ])
          ]))
        : (_openBlock(), _createElementBlock("p", _hoisted_11, " Les modes wallet prépayé et facture mensuelle arriveront dans une prochaine mise à jour du portail. Contactez le support Youdégo pour en discuter dès maintenant. "))
    ]),
    _createElementVNode("section", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        _cache[17] || (_cache[17] = _createElementVNode("div", null, [
          _createElementVNode("h3", { class: "font-semibold text-gray-900" }, "Équipe"),
          _createElementVNode("p", { class: "text-sm text-gray-500" }, " Les développeurs accèdent aux clés, aux webhooks, aux livraisons et à la documentation. ")
        ], -1)),
        (_unref(authStore).isOwner && !_unref(authStore).isSuspended)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (showModal.value = true)),
              class: "px-4 py-2 bg-[#8C0004] text-white rounded-lg text-sm font-medium hover:bg-red-900 flex items-center gap-2 flex-shrink-0"
            }, [
              _createVNode(_unref(Icon), {
                icon: "solar:user-plus-bold",
                class: "w-4 h-4"
              }),
              _cache[16] || (_cache[16] = _createTextVNode(" Inviter un développeur ", -1))
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_14, [
        (loading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [...(_cache[18] || (_cache[18] = [
              _createElementVNode("div", { class: "h-4 bg-gray-100 rounded w-1/3" }, null, -1)
            ]))]))
          : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(members.value, (m) => {
              return (_openBlock(), _createElementBlock("div", {
                key: m.id,
                class: "flex items-center justify-between p-4 hover:bg-gray-50"
              }, [
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _createVNode(_unref(Icon), {
                      icon: "solar:user-bold",
                      class: "w-4 h-4 text-gray-600"
                    })
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("p", _hoisted_19, _toDisplayString(m.user.firstname) + " " + _toDisplayString(m.user.lastname), 1),
                    _createElementVNode("p", _hoisted_20, _toDisplayString(m.user.phone), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("span", {
                    class: _normalizeClass([
                'px-3 py-1 rounded-full text-xs font-semibold',
                m.role === 'OWNER' ? 'bg-[#8C0004] bg-opacity-10 text-[#8C0004]' : 'bg-gray-100 text-gray-700'
              ])
                  }, _toDisplayString(m.role === 'OWNER' ? 'Propriétaire' : 'Développeur'), 3),
                  (_unref(authStore).isOwner && m.role !== 'OWNER')
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        onClick: ($event: any) => (removeMember(m)),
                        class: "text-xs text-[#8C0004] hover:underline"
                      }, " Retirer ", 8, _hoisted_22))
                    : _createCommentVNode("", true)
                ])
              ]))
            }), 128))
      ])
    ]),
    (showModal.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4",
          onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (showModal.value = false), ["self"]))
        }, [
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              _cache[19] || (_cache[19] = _createElementVNode("h3", { class: "text-lg font-bold text-gray-900" }, "Inviter un développeur", -1)),
              _createElementVNode("button", {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (showModal.value = false)),
                class: "text-gray-400 hover:text-gray-600"
              }, [
                _createVNode(_unref(Icon), {
                  icon: "solar:close-circle-bold",
                  class: "w-6 h-6"
                })
              ])
            ]),
            _createElementVNode("form", {
              onSubmit: _withModifiers(addMember, ["prevent"]),
              class: "p-6 space-y-4"
            }, [
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("div", null, [
                  _cache[20] || (_cache[20] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 mb-2" }, "Prénom", -1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.firstname) = $event)),
                    required: "",
                    class: "w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#8C0004]"
                  }, null, 512), [
                    [_vModelText, form.value.firstname]
                  ])
                ]),
                _createElementVNode("div", null, [
                  _cache[21] || (_cache[21] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 mb-2" }, "Nom", -1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.value.lastname) = $event)),
                    required: "",
                    class: "w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#8C0004]"
                  }, null, 512), [
                    [_vModelText, form.value.lastname]
                  ])
                ])
              ]),
              _createElementVNode("div", null, [
                _cache[22] || (_cache[22] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 mb-2" }, "Numéro WhatsApp", -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.value.phone) = $event)),
                  maxlength: "10",
                  placeholder: "0XXXXXXXXX",
                  required: "",
                  class: "w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#8C0004]"
                }, null, 512), [
                  [_vModelText, form.value.phone]
                ]),
                _cache[23] || (_cache[23] = _createElementVNode("p", { class: "text-xs text-gray-500 mt-2" }, " Il se connectera au portail avec ce numéro, par code WhatsApp. ", -1))
              ]),
              (error.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                    _createElementVNode("p", _hoisted_27, _toDisplayString(error.value), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("button", {
                  type: "button",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (showModal.value = false)),
                  class: "flex-1 px-4 py-2.5 border border-gray-300 rounded-lg text-sm font-medium hover:bg-gray-50"
                }, " Annuler "),
                _createElementVNode("button", {
                  type: "submit",
                  disabled: saving.value,
                  class: "flex-1 px-4 py-2.5 bg-[#8C0004] text-white rounded-lg text-sm font-medium hover:bg-red-900 disabled:opacity-50"
                }, _toDisplayString(saving.value ? 'Ajout...' : 'Inviter'), 9, _hoisted_29)
              ])
            ], 32)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})